// TODO: Find better place for MarkName type maybe override Slate types (Omit<keyof Text, 'text'>)
// TODO: Look for native solution in Slate

import { Editor, Text } from 'slate';
import matchNode from '@atlas/tool/box/slate/matchNode';

export default function isMarkActive(editor: Editor, mark: MarkName) {
    // While this looks cool and modern it breaks when navigating between table cells with arrow keys
    return !!matchNode(editor, (node) => Text.isText(node) && node[mark] !== undefined && node[mark] !== null);
}

// #region Types

export type MarkName = 'bold' | 'italic' | 'underline' | 'strikethrough' | 'code' | 'link';

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('isMarkActive', async () => {
        const { createEditor } = await import('slate');

        it('should return true if the mark is active', () => {
            const editor = createEditor();
            editor.children = [
                {
                    type: 'paragraph',
                    children: [{ text: 'Hello World', bold: true }],
                },
            ];
            editor.selection = { anchor: Editor.start(editor, [0]), focus: Editor.end(editor, [0]) };
            expect(isMarkActive(editor, 'bold')).toBe(true);
        });

        it('should return false if the mark is not active', () => {
            const editor = createEditor();
            editor.children = [
                {
                    type: 'paragraph',
                    children: [{ text: 'Hello World' }],
                },
            ];
            editor.selection = { anchor: Editor.start(editor, [0]), focus: Editor.end(editor, [0]) };
            expect(isMarkActive(editor, 'bold')).toBe(false);
        });
    });
}
